import './RightSidebar.scss'
import {useFlintNotificationContext} from "../page_components/common/notifications/FlintNotificationContext";

export default function RightSidebar() {
    const {rightSidebar} = useFlintNotificationContext();
    return (
        <div className={"right-sidebar"}>
            <div className={"right-sidebar-content"}>
                {rightSidebar?.get.children}
            </div>
        </div>
    );
}